import React from 'react';
import { Text, TextInput, TouchableRipple, Checkbox } from 'react-native-paper';
import { ArrowDown2, SearchNormal1, ArrowLeft2, ArrowRight2 } from 'iconsax-react-native';
import { View, TouchableOpacity, Platform, ScrollView, FlatList } from 'react-native';
import RBSheet from "react-native-raw-bottom-sheet";
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { getLocales } from 'expo-localization';

export default function Select({label, placeholder, options, selectedValue:value, onValueChange, onSelect, multiple, error}) {
  const refRBSheet = React.useRef();
  const insets = useSafeAreaInsets();
  const [searchValue, setSearchValue] = React.useState("");
  const [selectedValue, setSelectedValue] = React.useState("انتخاب کنید");
  const [selectedNames, setSelectedNames] = React.useState([]);
  const [values, setValues] = React.useState(value ? value : []);
  const [allSelected, setAllSelected] = React.useState(false);
  const memoizedData = React.useMemo(() => options, [options]);
  const deviceLanguage = getLocales()[0].languageCode;  

  React.useEffect(() => {
    if(value !== undefined) {
      if(Array.isArray(value)) {
        if(Object.keys(value).length === Object.keys(memoizedData).length) {
          setAllSelected(true);
        }
        
        let prevName = [...selectedNames];
        Object.values(options).map((option) => {
          Object.values(value).map((item) => {
            if(option.key == item) {
              prevName.push(option.value);
            }
          })
        })
        setSelectedNames([...prevName]);
        setSelectedValue(prevName.length > 0 ? [...prevName].join(", ") : 'انتخاب کنید')
      } else {
        Object.values(options).map((option) => {
          if(option.key == value) {
            setSelectedValue(option.value);
          }
        })
      }
    }
  }, [])

  const handlePresentModalPress = React.useCallback(() => {
    refRBSheet.current.open();
    setSearchValue("");
  }, []);

  const handleOnPress = React.useCallback((item) => {
    refRBSheet.current?.close();
    onValueChange(item.key);
    setValues(item.key);
    setSelectedValue(item.value);
    onSelect(item);
    setSearchValue("");
  }, []);

  const handleMultiplePress = (item) => {
    let prev = [...values];
    let itemIndex = prev.indexOf(item.key);
    if (itemIndex !== -1) {
      prev.splice(itemIndex, 1);
    } else {
      prev.push(item.key);
    }
    setValues([...prev]);
    onValueChange([...prev]);


    let prevName = [...selectedNames];
    let nameIndex = prevName.indexOf(item.value);
    if (nameIndex !== -1) {
      prevName.splice(nameIndex, 1);
    } else {
      prevName.push(item.value);
    }
    setSelectedNames([...prevName]);
    setSelectedValue([...prevName].join(", "))
  }

  const pressAll = () => {
    let key = [];
    let name = [];
    Object.values(memoizedData).map((item) => {
      key.push(item.key);
      name.push(item.value);
    });

    setValues(key);
    onValueChange(key);

    setSelectedNames(name);
    setSelectedValue(name.join(", "));

    setAllSelected(true);
  }

  const deSelectAll = () => {
    setAllSelected(false);

    setValues([]);
    onValueChange([]);

    setSelectedNames([]);
    setSelectedValue("انتخاب کنید");
  }

  const renderListItem = ({item}) => (
    <>
      {
        multiple ?
          <TouchableOpacity  
            onPress={() => handleMultiplePress(item)} 
            style={{ width: '100%', height: 48, borderBottomWidth: 1, borderBottomColor: '#BFC0C5', flexDirection: Platform.OS === 'web' ? 'row-reverse' : 'row', alignItems: 'center', justifyContent: 'space-between' }}
          >
            <Text style={{ fontSize: 14, color: '#292D32' }}>{item.value}</Text>
            <Checkbox status={Array.isArray(values) ? values.includes(item.key) ? 'checked' : 'unchecked' : 'unchecked'} />
          </TouchableOpacity>
        :
          <TouchableOpacity onPress={() => handleOnPress(item)} style={{ width: '100%', height: 48, borderBottomWidth: 1, borderBottomColor: '#BFC0C5', flexDirection: Platform.OS === 'web' ? 'row-reverse' : 'row', alignItems: 'center', justifyContent: 'space-between' }}><Text style={{ fontSize: 14, color: '#292D32' }}>{item.value}</Text><ArrowLeft2 size="24" color="#2F2F2F" variant="Outline"/></TouchableOpacity>
      }
    </>
  )
  
  return (
    <View style={{ flex: 1, marginBottom: 24 }}>
      <TouchableOpacity dir="rtl" onPress={handlePresentModalPress} style={{ height: 48, borderWidth: error ? 2 : 1, borderColor: error ? '#D61600' : '#BFC0C5', borderRadius: 4, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingHorizontal: 16 }}>
        <Text style={{ position: 'absolute', top: -12, left: Platform.OS === 'web' ? 'auto' : 10, right: Platform.OS === 'web' ? 10 : 'auto', fontSize: 12, color: error ? '#D61600' : '#BFC0C5', backgroundColor: '#fcfcfd', paddingHorizontal: 5 }}>{label}</Text>
        <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <Text style={{ width: '60%', fontSize: 14, color: '#5B5E63', textAlign: Platform.OS === 'web' ? 'right' : 'left' }} numberOfLines={1}>{selectedValue}</Text>
          <ArrowDown2 size="24" color="#999897" variant="Outline"/>
        </View>
      </TouchableOpacity>
      <RBSheet
        ref={refRBSheet}
        closeOnDragDown={true}
        closeOnPressMask={true}
        height={420}
        customStyles={{
          container: {
            paddingBottom: insets.bottom
          },
          wrapper: {
            backgroundColor: "rgba(0, 0, 0, 0.3)"
          },
          draggableIcon: {
            backgroundColor: "#555"
          }
        }}
      >
        <View style={{ paddingHorizontal: 18, marginBottom: 18, marginTop: 10 }}>
          <View style={{ flexDirection: Platform.OS === 'web' ? 'row-reverse' : 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
            <View style={{ flexDirection: Platform.OS === 'web' ? 'row-reverse' : 'row', alignItems: 'center' }}>
              <TouchableRipple dir="rtl" onPress={() => refRBSheet.current?.close()} borderless style={{ width: 40, height: 40, alignItems: 'center', justifyContent: 'center', borderRadius: 38, marginEnd: 8 }}><ArrowRight2 size="24" color="#292d32" variant="Outline"/></TouchableRipple>
              <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', textAlign: 'center' }}>{label} مورد نظر را انتخاب کنید</Text>
            </View>
            {multiple && <TouchableOpacity onPress={() => {setValues([]); onValueChange([]); setSelectedNames([]); setSelectedValue("انتخاب کنید")}}><Text style={{ fontSize: 11, color: '#D61600' }}>حذف همه</Text></TouchableOpacity>}
          </View>
          <TextInput
            label="جستجو"
            placeholder={placeholder}
            mode="outlined"
            activeOutlineColor="#c6c5c4"
            right={deviceLanguage === 'fa' ? <TextInput.Icon icon={() => <SearchNormal1 size="20" color="#666666" variant="Outline"/>} /> : null}
            left={deviceLanguage === 'fa' ? null : <TextInput.Icon icon={() => <SearchNormal1 size="20" color="#666666" variant="Outline"/>} />}
            style={{ width: '100%', fontSize: 14, color: '#C6C5C4' }}
            value={searchValue}
            onChangeText={text => setSearchValue(text)}
          />
        </View>
        {
          Platform.OS === 'web' ?
            <ScrollView contentContainerStyle={{ paddingHorizontal: 18 }}>
              {Object.values(memoizedData).filter((row) =>
                !searchValue.length || row.value
                .toString()
                .toLowerCase()
                .includes(searchValue.toString().toLowerCase()) 
              )
              .map((item) => renderListItem({item}))}
            </ScrollView>
          :
            <FlatList
              data={Object.values(memoizedData).filter((row) =>
                !searchValue.length || row.value
                .toString()
                .toLowerCase()
                .includes(searchValue.toString().toLowerCase()) 
              )}
              ListHeaderComponent={
                multiple ? 
                  <TouchableOpacity  
                    onPress={() => allSelected ? deSelectAll() : pressAll()}
                    style={{ width: '100%', height: 48, borderBottomWidth: 1, borderBottomColor: '#BFC0C5', flexDirection: Platform.OS === 'web' ? 'row-reverse' : 'row', alignItems: 'center', justifyContent: 'space-between' }}
                  >
                    <Text style={{ fontSize: 14, color: '#292D32' }}>انتخاب همه</Text>
                    <Checkbox status={allSelected ? 'checked' : 'unchecked'} />
                  </TouchableOpacity>
                : 
                  <></>
              }
              renderItem={renderListItem}
              initialNumToRender={10}
              contentContainerStyle={{ paddingHorizontal: 18, paddingVertical: 16 }}
              keyExtractor={item => item.id}
            />
        }
      </RBSheet>
    </View>
  );
}
